import types from './types'

export default {
  [types.GET_TOKEN]: ({ token }) => token,
  [types.GET_USER_ID]: ({ user: { id } }) => id
}
